/* @flow */
import * as React from 'react';

import Checkbox from 'components/Checkbox';
import Text from 'components/Text';
import Time from 'components/Time';

import './styles/AdminUpgradeQuoteBox.scss';

function Header(props: *) {
  return (
    <div className="AdminUpgradeQuoteBox-header">
      <Text element="div" size="medium" weight="semibold">
        {props.children}
      </Text>
    </div>
  );
}

type Props = {
  orgName: string,
  orgAddress: string,
  orgType: string,
  startDate: string,
  endDate: string,
  price: string,
  taxExempt: boolean,
  tax: string,
  handleTaxChange?: Function,
  persistingTaxExemption?: boolean,
  editable?: boolean,
};

const AdminUpgradeQuoteBox = function(props: Props) {
  const {
    orgName,
    orgAddress,
    orgType,
    startDate,
    endDate,
    price,
    taxExempt,
    tax,
    handleTaxChange,
    persistingTaxExemption,
    editable,
  } = props;
  const showTax = tax !== '$0.00' || taxExempt;

  return (
    <div className="AdminUpgradeQuoteBox">
      <div className="AdminUpgradeQuoteBox-organization">
        <div>
          <Header>{orgName}</Header>
          <Text element="div">{orgAddress}</Text>
        </div>
      </div>
      <div className="AdminUpgradeQuoteBox-quote">
        <div className="AdminUpgradeQuoteBox-quote-section">
          <div>
            <Header>Remind plan for 1 year</Header>
            <Text element="div" color="thunder">
              <Time date={new Date(startDate)} month="long" day="numeric" year="numeric" /> to{' '}
              <Time date={new Date(endDate)} month="long" day="numeric" year="numeric" />
            </Text>
          </div>
          <div>
            <Text element="div" size="medium" weight="semibold">
              {price}
            </Text>
          </div>
        </div>
        {showTax && (
          <div className="AdminUpgradeQuoteBox-quote-section">
            <div>
              <Header>Estimated sales tax</Header>
              {editable ? (
                <Checkbox
                  checked={taxExempt}
                  onChange={handleTaxChange}
                  label={`My ${orgType.toLowerCase()} is exempt from sales tax`}
                  disabled={persistingTaxExemption}
                />
              ) : null}
              {editable &&
                taxExempt && (
                  <Text element="div" color="thunder">
                    You’ll be asked to submit a tax exemption certificate with your payment.
                  </Text>
                )}
            </div>
            <div>
              <Text element="div" color="thunder">
                {tax}
              </Text>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminUpgradeQuoteBox;
